import { ab } from "../public/js/core/abMock";
import { getRandomNumeric, getRegionMap } from "./CommonUtils";

const MOBILE_USER_AGENT_PATTERN =
  /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i;

function resolveIsDeviceMobile(data) {
  if (typeof data?.isDeviceMobile === "boolean") {
    return data.isDeviceMobile;
  }
  return false;
}

export function populateHeader(data, header) {
  const { isGoibibo = false, dvid } = data || {};
  const isDeviceMobile = resolveIsDeviceMobile(data);

  const headersMap = { ...header };
  const mcid = dvid;
  const deviceId = dvid;
  const appVer = "app-ver";
  const devId = "device-id";
  headersMap[appVer] = "1.0.0";
  headersMap.os = "Linux";
  headersMap.pfm = isDeviceMobile ? "PWA" : "DESKTOP";
  headersMap.src = isGoibibo ? "gi" : "mmt";
  headersMap.mcid = mcid;
  headersMap[devId] = deviceId;
  headersMap.Accept = "application/json";
  headersMap.source = isGoibibo ? "GI" : "MMT";
  headersMap.lob = "B2C";
  if (!isGoibibo) {
    headersMap.ab = JSON.stringify(ab.data);
  }

  const regionMap = getRegionMap("headers", data) || {};
  return { ...headersMap, ...regionMap };
}
